export const GAME_STATES = {
  LOADING: "LOADING",
  LOADED: "LOADED",
  INGAME: "INGAME",
  OVER_VICTORY: "OVER_VICTORY",
  OVER_DEFEAT: "OVER_DEFEAT",
}

export const COUNTRIES = {
  0: "FRANCE",
  1: "BELGIUM",
  2: "ITALY",
  3: "POLAND"
}


export const SHEETNAMES = {
  AEP: "AEP",
  INDICATORS: "indicators",
  PARAMETERS: "parameters",
  PARAMETERS2: "parameters_2",
}




// la config pour le xlsx de l'interface
export const MARKERS_KEYS = {
   MARKER_ID: "MarkerId",
   MARKER_NAME: "Marker name",
   MARKER_X: "Xpos",
   MARKER_Y: "Ypos",
   AEPS: "AEP Categories",
   REL_INDS: "Indicators",
   SHOW_NULL_INDICATORS: "Show_null_indicators",
   CUSTOM_CONTENT: "custom_content_id"
  }



export const COLORS = [

  "#ff48c4",
  "#2bd1fc",
  "#008000",
  "#a52a2a",
  "#c04df9",
  "#ff3f3f",
  "#5d8aa8",
  "#918151",
  "#ffbf00",
  "#ff033e",
  "#915c83",
  "#8db600",
  "#21abcd",
  "#3d2b1f",
  "#fe6f5e",
  "#000000",
  "#318ce7",
  "#0000ff",
  "#0d98ba",
  "#8a2be2",
  "#de5d83",
  "#79443b",
  "#0095b6",
  "#cc0000",
  "#006a4e",
  "#873260",
  "#0070ff",
  "#b5a642",
  "#cb4154",
  "#1dacd6",
  "#66ff00",
  "#bf94e4",
  "#c32148",
  "#08e8de",
  "#004225",
  "#cd7f32",
  "#480607",
  "#8a3324",
  "#bd33a4",
  "#702963",
  "#007aa5",
  "#e03c31",
  "#536872",
  "#5f9ea0",
  "#006b3c",
  "#ed872d",
  "#e30022",
  "#fff600",
  "#a67b5b",
  "#4b3621",
  "#1e4d2b",
  "#00bfff",
  "#592720",
  "#c41e3a",
  "#00cc99",
  "#ffa6c9",
  "#b31b1b",
  "#1a2421",
  "#bdb76b",
  "#483c32",
  "#734f96",
  "#8b008b",
  "#003366",
  "#556b2f",
  "#ff8c00",
  "#9932cc",
  "#779ecb",
  "#03c03c",
  "#966fd6",
  "#c23b22",
  "#e75480",
  "#003399",
  "#872657",
  "#8b0000",
  "#e9967a",
  "#560319",
  "#8fbc8f",
  "#3c1414",
  "#483d8b",
  "#2f4f4f",
  "#177245",
  "#ffa812",
  "#483c32",
  "#cc4e5c",
  "#00ced1",
  "#9400d3",
  "#00693e",
  "#555555",
  "#d70a53"
]
